import { Stack, Box, Button } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import DynamicTable from "../DynamicTable/DynamicTable";
import DataItem from "@components/atoms/DataItem/DataItem";
import { getCurrency } from "@utils/utils";
import MessageBar from "@components/atoms/MessageBar/MessageBar";
import { IRemisionDetailUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import RemisionPaymentInfo from "../../molecules/RemisionPaymentInfo/RemisionPaymentInfo";
import ConfirmDialog from "@components/molecules/ConfirmDialog/ConfirmDialog";
import DispatchDialog from "@components/molecules/DispatchDialog/DispatchDialog";
import InputText from "@components/atoms/InputText/InputText";
import { useForm } from "react-hook-form";
const ACTION_LABELS: Record<"approve" | "revoke" | "close", {
  title: string;
  confirm: string;
}> = {
  approve: {
    title: "Aprobar despacho",
    confirm: "Aprobar"
  },
  revoke: {
    title: "Revocar aprobación",
    confirm: "Revocar"
  },
  close: {
    title: "Cerrar remisión",
    confirm: "Cerrar"
  }
};
const TopRender = ({
  type,
  clientName,
  creationTime,
  limitDate,
  createdBy,
  lastModifiedBy
}: {
  type: number;
  clientName: string;
  creationTime: string;
  limitDate: string;
  createdBy: string;
  lastModifiedBy: string;
}) => <>
    <Stack direction={"row"} justifyContent={"space-between"} marginBottom={1} flexWrap={"wrap"} width={1}>
      <DataItem label="Cliente" value={clientName} />
      <DataItem label="Fecha de creación" value={creationTime} />
      {type !== 1 ? <DataItem label="Fecha límite de pago" value={limitDate} /> : <DataItem label="" value="" />}
    </Stack>
    <Stack direction={"row"} justifyContent={"space-between"} marginBottom={1} flexWrap={"wrap"} width={1}>
      <DataItem label="Creado por" value={createdBy || "N/A"} />
      <DataItem label="Última modificación" value={lastModifiedBy || "N/A"} />
      <DataItem label="" value="" />
    </Stack>
  </>;
const RemisionDetailUI = ({
  id,
  name,
  type,
  clientName,
  creationTime,
  limitDate,
  createdByEmployeeName,
  lastModifiedByEmployeeName,
  total,
  total2,
  headers,
  rows,
  rows2,
  headers2,
  pages,
  onChangePage,
  onChangePage2,
  isLoading,
  showError,
  closeError,
  errorMessage,
  remision,
  setRemision,
  showDialog,
  handleConfirmDialog,
  handleCloseDialog,
  employeeCode,
  setEmployeeCode,
  applicant,
  setApplicant,
  canApprove,
  canRevoke,
  canClose,
  onApproveClick,
  onRevokeClick,
  onCloseClick,
  showActionDialog,
  handleConfirmAction,
  handleCloseActionDialog,
  actionType,
  actionEmployeeCode,
  setActionEmployeeCode,
  isActionLoading,
  dispatchTarget,
  dispatchAmount,
  setDispatchAmount,
  dispatchErrorMessage,
  dispatchWarehouses,
  dispatchWarehousesStatus,
  dispatchWarehouseId,
  setDispatchWarehouseId
}: IRemisionDetailUI) => {
  const classes = {
    innerStack: {
      width: 1,
      "& > div:nth-of-type(1)": {
        marginTop: 0
      }
    }
  };
  const {
    register
  } = useForm();
  const {
    register: registerAction
  } = useForm();
  const actionLabels = actionType && actionType !== "dispatch" ? ACTION_LABELS[actionType] : null;
  return <>
      <TitlePage title={`Remisión #${id}, ${name}`} subtitle="Accede a información detallada sobre tu remisión, desde los productos hasta el monto total y la fecha de vencimiento." />

      {(canApprove || canRevoke || canClose) && <Stack direction="row" spacing={1} marginTop={2} flexWrap="wrap">
          {canApprove && <Button variant="contained" color="warning" onClick={onApproveClick} disabled={isLoading}>
              Aprobar despacho
            </Button>}
          {canRevoke && <Button variant="outlined" color="warning" onClick={onRevokeClick} disabled={isLoading}>
              Revocar aprobación
            </Button>}
          {canClose && <Button variant="contained" color="secondary" onClick={onCloseClick} disabled={isLoading}>
              Cerrar remisión
            </Button>}
        </Stack>}

      <Stack direction={"row"} marginTop={3} spacing={3} alignItems={"flex-start"}>
        <Stack sx={classes.innerStack}>
          {type !== 1 && <DynamicTable title="Información de la remisión" subtitle="Resumen de productos, cliente y su fecha de pago." headers={headers} rows={rows} pages={pages} onChangePage={onChangePage} isLoading={isLoading} topRender={<TopRender type={type} clientName={clientName} creationTime={creationTime} limitDate={limitDate} createdBy={createdByEmployeeName} lastModifiedBy={lastModifiedByEmployeeName} />} bottomRender={<MessageBar label="Total productos" value={getCurrency(total)} />} />}
          {rows2.length > 0 && <DynamicTable title="Devoluciones" subtitle="Productos que han sido devueltos" headers={headers2} rows={rows2} pages={pages} onChangePage={onChangePage2} isLoading={isLoading} {...type === 1 && {
          topRender: <TopRender type={type} clientName={clientName} creationTime={creationTime} limitDate={limitDate} createdBy={createdByEmployeeName} lastModifiedBy={lastModifiedByEmployeeName} />
        }} bottomRender={<MessageBar label="Total devoluciones" value={total2} />} />}
        </Stack>
        <RemisionPaymentInfo remision={remision} setRemision={setRemision} />
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />

      {/* Delete product dialog */}
      <ConfirmDialog open={showDialog} cancelAction={handleCloseDialog} confirmAction={handleConfirmDialog} title="Eliminar producto" subtitle="¿Estás seguro de que deseas eliminar este producto?" message="Recuerda, si eliminas el producto no podrás recuperar la información una vez que se haya eliminado." cancelLabel="No eliminar" confirmLabel="Sí, eliminar" employeeCode={employeeCode} setEmployeeCode={setEmployeeCode} requireEmployeeCode={true} withEnter={true} withEscape={true} contentRender={<Box marginTop={1}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode,
        required: true
      })} type="password" disabled={isLoading} sx={{
        mb: 2
      }} autoFocus={true} />
            <InputText label="Solicitante" name="applicant" placeholder="Ingresa el nombre del solicitante" register={register("applicant", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setApplicant(e.target.value),
        value: applicant || ""
      })} disabled={isLoading} sx={{
        mb: 2
      }} />
          </Box>} />

      {/* Lifecycle action dialog (approve / revoke / close) */}
      {actionLabels && <ConfirmDialog open={showActionDialog} cancelAction={handleCloseActionDialog} confirmAction={handleConfirmAction} title={actionLabels.title} subtitle="Ingresa tu código de empleado para confirmar." message="" cancelLabel="Cancelar" confirmLabel={actionLabels.confirm} disabled={!actionEmployeeCode.trim() || isActionLoading} withEnter={true} withEscape={true} contentRender={<Box marginTop={1}>
              <InputText label="Código de empleado" name="actionEmployeeCode" placeholder="Ingresa tu código de empleado *" register={registerAction("actionEmployeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setActionEmployeeCode(e.target.value),
        value: actionEmployeeCode,
        required: true
      })} type="password" disabled={isActionLoading} sx={{
        mb: 2
      }} autoFocus={true} />
            </Box>} />}

      {/* Dispatch-by-quantity dialog */}
      {actionType === "dispatch" && dispatchTarget && <DispatchDialog open={showActionDialog} productName={dispatchTarget.productName} quantity={dispatchTarget.quantity} dispatchedQuantity={dispatchTarget.dispatchedQuantity ?? 0} amount={dispatchAmount} setAmount={setDispatchAmount} employeeCode={actionEmployeeCode} setEmployeeCode={setActionEmployeeCode} warehouses={dispatchWarehouses} warehousesStatus={dispatchWarehousesStatus} warehouseId={dispatchWarehouseId} setWarehouseId={setDispatchWarehouseId} onConfirm={handleConfirmAction} onCancel={handleCloseActionDialog} isLoading={isActionLoading} errorMessage={dispatchErrorMessage} />}
    </>;
};
export default RemisionDetailUI;